(function (angular, schoolwork12) {

    'use strict';
    var submissionsApp = angular.module(schoolwork12.app.submission.name, [ 
    	'ui.grid', 'ui.grid.resizeColumns', 'ui.grid.pagination',
		'ui.grid.selection', 'ui.grid.exporter' ]);

    submissionsApp.controller(schoolwork12.app.submission.controllers.submissionLogs, [
        '$rootScope', '$scope', '$http', '$timeout', '$interval',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
         schoolwork12.app.submission.services.submissionLogsSvc,
        function ($rootScope, $scope, $http, $timeout, $interval, authentication, 
        	      eventNotification, submissionLogsSvc) {

        	console.info("In submissions controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Submissions controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));
						// valid roles for submission log page
						$scope.mainModel.hasAdministratorRole = authentication
						.hasAdministratorRole();				
						$scope.mainModel.hasBulkAttendanceAdjusterRole = authentication
								.hasBulkAttendanceAdjusterRole();
						$scope.mainModel.hasBulkEditAdditionRequirementRole = authentication.hasBulkEditAdditionRequirementRole();
						$scope.mainModel.hasBulkGradPlanImportRole = authentication.hasBulkGradPlanImportRole();
						$scope.mainModel.hasbulkSchoolDataRole = authentication.hasbulkSchoolDataRole();
						$scope.mainModel.hasbulkStudentCreateRole = authentication.hasbulkStudentCreateRole();
                });
           
            //Initialize global variables and functions
            $scope.submissionErrorMesg = "";
			$scope.submissionErrorOccurred = false;
            $scope.submissions = {type : ''};
           
            //Initialize submissions grid 
            $scope.gridOptions = {
		     	enableFiltering : true,
				enableGridMenu : true,
				exporterMenuPdf : false,
				paginationPageSizes : [ 25, 50, 75 ],
				paginationPageSize : 25,
				rowHeight: 50,
				enableRowSelection : true,
				enableRowHeaderSelection : true,
		    };
			$scope.mainModel = {};
			// valid roles for submission log page
			if (authentication
					&& authentication.isAuthenticated()) {				
				$scope.mainModel.hasAdministratorRole = authentication
						.hasAdministratorRole();				
				$scope.mainModel.hasBulkAttendanceAdjusterRole = authentication
						.hasBulkAttendanceAdjusterRole();
				$scope.mainModel.hasBulkEditAdditionRequirementRole = authentication.hasBulkEditAdditionRequirementRole();
				$scope.mainModel.hasBulkGradPlanImportRole = authentication.hasBulkGradPlanImportRole();
				$scope.mainModel.hasbulkSchoolDataRole = authentication.hasbulkSchoolDataRole();
				$scope.mainModel.hasbulkStudentCreateRole = authentication.hasbulkStudentCreateRole();
			};		

		    //Custom cell template for Status and Error excel files download link
		    var statusCellTemplate = '<div class="ui-grid-cell-contents"> {{grid.getCellValue(row, col)}}' +  
		    '<a target="_self" ng-click="grid.appScope.downloadErrorLogs(row)" class="errorLogs" ng-show="row.entity.status == \'Completed With Error\'" title="Download Error Logs">' + 
		    '<img src="images/Excel_icon.gif"></i>Error Log</a>' + 
		    '</div>';
			// this function is defined to only set the column definitions for submission log table
			var buildLogGridColumns = function(){
				if($scope.submissions.type){
					if($scope.submissions.type==='studentClassroom'){
						//Build column definitions	
						$scope.gridOptions.columnDefs = [
							{ field: 'requestID', displayName: 'Request ID', width: '10%'},
							{ field: 'status', displayName: 'Status', width: '20%'},
							{ field: 'dateAndTimeSubmitted', displayName: 'Date and Time Submitted', cellTemplate: '<div class="ui-grid-cell-contents dateTime" >{{grid.getCellValue(row, col)}}</div>', width: '18%'},
							{ field: 'totalStudentsSubmitted', displayName: 'Total Students Submitted', width: '15%'},
							{ field: 'totalStudentsAdded', displayName: 'Total Students Added', width: '15%'},
							{ field: 'totalStudentsWithIssues', displayName: 'Total Students with Issues', width: '20%', 
							cellTemplate: statusCellTemplate
							},  
						];
					} else if($scope.submissions.type==='studentBulkAttAdj'){
						//Build column definitions	
						$scope.gridOptions.columnDefs = [
							{ field: 'requestID', displayName: 'Request ID', width: '10%'},
							{ field: 'status', displayName: 'Status', width: '20%'},
							{ field: 'dateAndTimeSubmitted', displayName: 'Date and Time Submitted', cellTemplate: '<div class="ui-grid-cell-contents dateTime" >{{grid.getCellValue(row, col)}}</div>', width: '18%'},
							{ field: 'totalAttAdjSubmitted', displayName: 'Total Attendance Adjustments Submitted', width: '15%'},
							{ field: 'totalAttAdjAdded', displayName: 'Total Attendance Adjustments Added/Edited/Deleted', width: '15%'},
							{ field: 'totalAttAdjWithIssues', displayName: 'Total Attendance Adjustments with Issues', width: '20%', 
							cellTemplate: statusCellTemplate
							},  
						];
					} else if($scope.submissions.type==='studentBulkAddReq'){
						//Build column definitions	
						$scope.gridOptions.columnDefs = [
							{ field: 'requestID', displayName: 'Request ID', width: '10%'},
							{ field: 'status', displayName: 'Status', width: '20%'},
							{ field: 'dateAndTimeSubmitted', displayName: 'Date and Time Submitted', cellTemplate: '<div class="ui-grid-cell-contents dateTime" >{{grid.getCellValue(row, col)}}</div>', width: '18%'},
							{ field: 'totalAddReqSubmitted', displayName: 'Total Additional Requirements Submitted', width: '15%'},
							{ field: 'totalAddReqEdited', displayName: 'Total Additional Requirements Edited', width: '15%'},
							{ field: 'totalAddReqWithIssues', displayName: 'Total Additional Requirements with Issues', width: '20%', 
							cellTemplate: statusCellTemplate
							},  
						];
					} else if($scope.submissions.type==='studentBulkGradPlan'){
						//Build column definitions	
						$scope.gridOptions.columnDefs = [
							{ field: 'requestID', displayName: 'Request ID', width: '10%'},
							{ field: 'status', displayName: 'Status', width: '20%'},
							{ field: 'dateAndTimeSubmitted', displayName: 'Date and Time Submitted', cellTemplate: '<div class="ui-grid-cell-contents dateTime" >{{grid.getCellValue(row, col)}}</div>', width: '18%'},
							{ field: 'totalGradPlanSubmitted', displayName: 'Total Student Grad Plan Rows Submitted', width: '15%'},
							{ field: 'totalGradPlanAdded', displayName: 'Total Student Grad Plan Rows Added/Edited/Deleted', width: '15%'},
							{ field: 'totalGradPlanWithIssues', displayName: 'Total Student Grad Plan Rows with Issues', width: '20%', 
							cellTemplate: statusCellTemplate
							},  
						];
					} else if($scope.submissions.type==='courseUploadLog'){
						//Build column definitions	
						$scope.gridOptions.columnDefs = [
							{ field: 'requestID', displayName: 'Request ID', width: '10%'},
							{ field: 'status', displayName: 'Status', width: '20%'},
							{ field: 'dateAndTimeSubmitted', displayName: 'Date and Time Submitted', cellTemplate: '<div class="ui-grid-cell-contents dateTime" >{{grid.getCellValue(row, col)}}</div>', width: '18%'},
							{ field: 'totalCourseCatalogsSubmitted', displayName: 'Total Course Catalog Rows Submitted', width: '15%'},
							{ field: 'totalCourseCatalogsAdded', displayName: 'Total Course Catalog Rows Successful', width: '15%'},
							{ field: 'totalCourseCatalogsWithIssues', displayName: 'Total Course Catalog Rows with Issues', width: '20%', 
							cellTemplate: statusCellTemplate
							},  
						];
					} else if($scope.submissions.type==='bulkSchoolHoliday'){
						//Build column definitions	
						$scope.gridOptions.columnDefs = [
							{ field: 'requestID', displayName: 'Request ID', width: '10%'},
							{ field: 'status', displayName: 'Status', width: '20%'},
							{ field: 'dateAndTimeSubmitted', displayName: 'Date and Time Submitted', cellTemplate: '<div class="ui-grid-cell-contents dateTime" >{{grid.getCellValue(row, col)}}</div>', width: '18%'},
							{ field: 'totalSchoolHolidaySubmitted', displayName: 'Total School Holiday Rows Submitted', width: '15%'},
							{ field: 'totalSchoolHolidayAdded', displayName: 'Total School Holiday Rows Successful', width: '15%'},
							{ field: 'totalSchoolHolidayWithIssues', displayName: 'Total School Holiday Rows with Issues', width: '20%', 
							cellTemplate: statusCellTemplate
							},  
						];
					} else if($scope.submissions.type==='bulkSchoolDates'){
						//Build column definitions	
						$scope.gridOptions.columnDefs = [
							{ field: 'requestID', displayName: 'Request ID', width: '10%'},
							{ field: 'status', displayName: 'Status', width: '20%'},
							{ field: 'dateAndTimeSubmitted', displayName: 'Date and Time Submitted', cellTemplate: '<div class="ui-grid-cell-contents dateTime" >{{grid.getCellValue(row, col)}}</div>', width: '18%'},
							{ field: 'totalSchoolDatesSubmitted', displayName: 'Total School Dates Rows Submitted', width: '15%'},
							{ field: 'totalSchoolDatesAdded', displayName: 'Total School Dates Rows Successful', width: '15%'},
							{ field: 'totalSchoolDatesWithIssues', displayName: 'Total School Dates Rows with Issues', width: '20%', 
							cellTemplate: statusCellTemplate
							},  
						];
					} else if($scope.submissions.type==='bulkCreateUpdateStudent'){
						//Build column definitions	
						$scope.gridOptions.columnDefs = [
							{ field: 'requestID', displayName: 'Request ID', width: '10%'},
							{ field: 'status', displayName: 'Status', width: '20%'},
							{ field: 'dateAndTimeSubmitted', displayName: 'Date and Time Submitted', cellTemplate: '<div class="ui-grid-cell-contents dateTime" >{{grid.getCellValue(row, col)}}</div>', width: '18%'},
							{ field: 'totalStudentRowsSubmitted', displayName: 'Total Student Rows Submitted', width: '15%'},
							{ field: 'totalStudentRowsSuccessful', displayName: 'Total Student Rows Successful', width: '15%'},
							{ field: 'totalStudentRowsWithIssues', displayName: 'Total Student Rows with Issues', width: '20%', 
							cellTemplate: statusCellTemplate
							},  
						];
					}
				}
			}

			//Get submission logs for adding students to classroom	
			$scope.getSubmissionLogsList = function(){
			   	buildLogGridColumns();
			   	$scope.displaySubmissionGrid = false;
			   	var submissionLogsPromise = null;
			   	//common function defined to fetch submission logs list service
			   	var getsubmissionListSvc = function(){
			   	 	submissionLogsPromise = submissionLogsSvc.getAllSubmissionLogs(authentication.getCurrentUser().keycode, $scope.submissions.type);
	                submissionLogsPromise.then(function (data) { 
						if(data && data.length>0){
	                    console.info("Viewing submission logs grid");                   
		                    $scope.submissionLogsData = data;
							$scope.submissionErrorOccurred = false;
		             	    $scope.displaySubmissionGrid = true;
		             	    $scope.refreshMessage ="This page refreshes every 60 seconds";
		             	    $scope.gridOptions.data = $scope.submissionLogsData;
						}else{
							$scope.submissionErrorOccurred = true;
							$scope.submissionErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
							$scope.displaySubmissionGrid = false;
						}
						$scope.isSubmissionSearchBusy = false;
	                }, function (error) {
	                    console.info('Error in viewing submission logs grid....'.concat(angular.toJson(error)));   
	                    $scope.submissionErrorOccurred = true;
						$scope.isSubmissionSearchBusy = false;
	                	if (error.status == 400) {
							for ( var j = 0; j < error.data._errors.length; j++) {
								$scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
							}
						} else if (error.status == 401 || error.status == 403) {
	                        $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
	                    } else {
	                        $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
	                    }

	                });
			   	}

	           $scope.isSubmissionSearchBusy = true;
	            if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
	                console.info('Keycode found. Making a call to service');
	                //invoking getsubmissionListSvc()
	                getsubmissionListSvc();
	            } else {
	                console.info('Key code not found. Using time out function to make a call');
	                $timeout(function () {
	                //invoking getsubmissionListSvc()
	                getsubmissionListSvc();
	                }, 500);
	            };
        	};


		   	//Download error logs
		   	$scope.downloadErrorLogs=function(row){
       			$http({
                    url: schoolwork12.app.submission.endpoints.getSubmissionsLogsEndpoint + $scope.submissions.type + '/error/' + row.entity.requestID,
                    method: "GET",
                    responseType: 'arraybuffer',
                    headers : {
                        'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                    }
               	}).success(function (data, status, headers, config) {
               	    console.info("Downloading error logs");
                        var header = headers('Content-Disposition')
                        var fileName = (header.split("=")[1].replace(/\"/gi,'')).split(".")[0];    
                        var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                        var objectUrl = URL.createObjectURL(blob);
               
                        var a = document.createElement("a");
                        a.href = objectUrl;
                        a.download = fileName+".xlsx";
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);                                 
                }).error(function (error) {
                    console.info('Error in viewing submission logs grid....'.concat(angular.toJson(error)));   
                    $scope.submissionErrorOccurred = true;
                	if (error.status == 400) {
						for ( var j = 0; j < error.data._errors.length; j++) {
							$scope.submissionErrorMesg = $scope.submissionErrorMesg + error.data._errors[j] + "\n";
						}
					} else if (error.status == 401 || error.status == 403) {
                        $scope.submissionErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.submissionErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
               	});
       		};

       		//Refresh grid every 60 seconds
			var refreshGridTimer = 
			    $interval(function () {
			    	if($scope.displaySubmissionGrid){
			    		$scope.getSubmissionLogsList();
				    	console.log("Submission Logs refreshes every 60 seconds");
			    	}
			}, 60000); 

			//Cancel refresh timer
			$scope.$on('$destroy', function () {
			 	if(angular.isDefined(refreshGridTimer)){
				 	$interval.cancel(refreshGridTimer);
		            refreshGridTimer = undefined;
		            console.log("Cancel Refresh Timer");
	       		}
			});

    }]);

}(angular, schoolwork12));